import React from "react";
import { ArrowUpRight, CirclePlay, Clock3, FileText, HardHat, LayoutDashboard, Receipt, Ticket, UserCog, Users, Wallet } from "lucide-react";
import { Link } from "react-router-dom";
import { VIDEO_GROUPS, videoDuration, videoGroup, videoPath } from "@/lib/publicTutorials";
import { VideoShareButton } from "./VideoShareButton";
import { workerTutorialRole } from "@/lib/tutorialLanguages";

const icons = { dashboard: LayoutDashboard, tickets: Ticket, invoices: FileText, expenses: Receipt, payments: Wallet, payroll: Users, statement: FileText, managers: Users, worker: HardHat, manager: UserCog };
export const PublicVideoCard = ({ item, index }) => {
  const id = `${item.audience}-${item.section}`;
  const group = videoGroup(item);
  const Icon = icons[item.audience === "worker" ? workerTutorialRole(item.section) : item.section] || CirclePlay;
  return <article className={`pv-card pv-group-${group}`} style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }} data-testid={`video-card-${id}`}>
    <Link to={videoPath(item)} className="pv-card-main" data-testid={`video-watch-${id}`} aria-label={`Watch ${item.title} — ${VIDEO_GROUPS[group]}`}>
      <div className="pv-card-symbols"><span className="pv-section-icon"><Icon size={26} /></span><ArrowUpRight size={19} className="pv-open-arrow" /></div>
      <span className="pv-audience" data-testid={`video-audience-${id}`}>{VIDEO_GROUPS[group]}</span>
      <h2 data-testid={`video-title-${id}`}>{item.title}</h2>
      <span className="pv-duration" data-testid={`video-duration-${id}`}><Clock3 size={13} />{videoDuration(item.duration_seconds)}</span>
    </Link>
    <div className="pv-card-actions"><Link to={videoPath(item)} data-testid={`video-play-${id}`} className="pv-play-link"><CirclePlay size={18} />Watch video</Link>
      <VideoShareButton item={item} className="pv-copy" />
    </div>
  </article>;
};